<div id="containerone">
    <div id="checkCircle"><i class="fa fa-check fa-3x" id="check" aria-hidden="true"></i></div>
    <h1 id="maintext" mat-dialog-title>Deleted!</h1>
    <h2 id="subtext"mat-dialog-content>Your data has been deleted</h2>
    <div mat-dialog-actions>
    <button id="okbtn" (click)="close()"  mat-button [mat-dialog-close]="true" cdkFocusInitial>ok</button>
    </div>
</div>
